import { render, staticRenderFns } from "./edit-user-dialog.vue?vue&type=template&id=08198bac&scoped=true"
import script from "./edit-user-dialog.vue?vue&type=script&lang=js"
export * from "./edit-user-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-user-dialog.vue?vue&type=style&index=0&id=08198bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08198bac",
  null
  
)

export default component.exports